export class Model_CRM_Account_Info
{
    public  LeadId : number;   
    public  GstNo  : string;
    public  PanNo : string;   
      
}